import Link from 'found/lib/Link';
import PropTypes from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import HTMLFragment from 'components/HTMLFragment';

const styles = {
  p: {
    fontSize: 12,
    textAlign: 'justify',
  },
};

class CommunityWaiver extends PureComponent {
  static propTypes = {
    community: PropTypes.object.isRequired,
  };

  render() {
    const { community, ...props } = this.props;
    return (
      <div {...props}>
        {community?.terms ? (
          <HTMLFragment>{community?.terms}</HTMLFragment>
        ) : (
          <Fragment>
            <h5>Community Waiver</h5>
            <p style={styles.p}>
              In consideration of House Party, Inc. d/b/a Ripple Street
              (&quot;HPI&quot;) allowing me to participate in HPI community
              activities including allowing me to participate as a host and/or
              attend a registered House Party event, (“House Party Event”),
              including, without limitation, participating in House Party Event
              activities, such as product demonstrations and sampling, and
              educational and informational activities (collectively, the
              “Activities”), for HPI’s client,{' '}
              <HTMLFragment>{community?.name}</HTMLFragment> (“Client”) I hereby
              agree as follows:
            </p>
            <p style={styles.p}>
              I am eighteen (18) years of age or older. I agree that as
              consideration for being permitted to participate in the community
              and/or host and/or participate in any of the Activities, I, on
              behalf of myself and my children and minors for whom I am a legal
              guardian, hereby grant HPI and its designees (including, without
              limitation, Client and its designees) and their respective
              affiliates, licensees, permitees, successors and assigns, and each
              of them, an unrestricted, absolute, universal, perpetual,
              irrevocable, non-royalty bearing, and transferable right and
              license (but not any obligation) to use, copy, transmit,
              distribute, display, modify, perform, present, publish, transform,
              create works and derivative works, and otherwise promote or
              utilize my name, image, likeness, voice, words and/or other
              personal attribute(s) or other personal information, and those of
              my children and minors for whom I am a legal guardian
              (collectively, “Personal Attributes”), captured, photographed or
              otherwise recorded or memorialized in any manner by myself or any
              other person in connection with any of the Activities, in any
              medium or format whether now or hereafter existing (including,
              without limitation, print, direct mail, online (including the HPI
              Facebook page as well as those of its Clients), mobile or wireless
              communications, radio or television broadcast, telecast or
              photograph), for any purpose whatsoever (including, without
              limitation, in connection with the creation, advertising, sale
              and/or promotion of any products and/or services), and without any
              consideration or notice to or consent by me or any third party. I,
              on behalf of myself and my children and minors for whom I am a
              legal guardian, hereby forever and irrevocably waive any rights
              any of us may have in or to any of the foregoing, and I understand
              and agree that HPI and its designees (including, without
              limitation, Client and its designees) are the exclusive owners (to
              the extent the materials are created by or at the direction of
              each such party) of any and all right, title and interest,
              including copyright, in and to any materials of any kind or nature
              containing or developed from use of our respective Personal
              Attributes. Without limiting the foregoing, I understand and agree
              that such materials may be used in whole or in part, individually
              or in conjunction with other photographs or images, and neither I,
              my children nor minors for whom I am a legal guardian shall have
              any right of approval or notice, any claim to any compensation, or
              any claim arising out of the use, alteration, distortion or
              illusionary effect or use in any composite form of any of our
              respective Personal Attributes.
            </p>
            <p style={styles.p}>
              I understand that the information I have given to HPI online
              (including, without limitation, in connection with the host and/or
              guest registration and RSVP process as well as the addition of any
              information to the community) may be used to provide me with
              additional information about Client. I also agree that Ripple
              Street may use and share my personal information as described in
              the <Link to='/privacy'>Ripple Street Privacy Policy</Link>.
            </p>
            <p style={styles.p}>
              I acknowledge that I have read and understand the HPI disclosure
              guidelines regarding my postings on the community and/or party
              Microsite as well as other social media platforms. I understand
              that I must follow all disclosure guidelines. In the event that I
              do not make proper disclosures, I understand that I may not be
              allowed to participate in future House Party Events.
            </p>
            <p style={styles.p}>
              I, on behalf of myself, my children and minors for whom I am a
              legal guardian, and anyone who obtains any rights from or through
              any of us, hereby forever and irrevocably release and discharge
              HPI and Client; their respective parents, subsidiaries,
              affiliates, partners, members, managers, agents, licensees,
              designees, insurers, personal and legal representatives,
              successors and assigns; House Party Event hosts; other
              participants in the Activities; and any director, officer,
              employee or agent of any of the foregoing (each considered one of
              the “Releasees” herein) from any and all liability, claims,
              demands, losses, damages, costs or expenses (including, without
              limitation, attorneys’ fees and costs) (collectively, “Losses”)
              arising out of or in any way related to the hosting of, or
              participation in or attendance at the Activities, by myself or my
              children or minors for whom I am a legal guardian, including, but
              not limited to, Losses (including, without limitation, Losses from
              BODILY INJURY, ILLNESS OR DEATH) caused or alleged to be CAUSED IN
              WHOLE OR IN PART BY (i) THE NEGLIGENCE OR MISCONDUCT of any
              Releasee or otherwise, including negligent rescue operations, (ii)
              any claim, action, suit or demand brought by any third party
              against any Releasee by reason of or in connection with the
              hosting of, or participation in or attendance at the Activities,
              by myself or my children or minors for whom I am a legal guardian,
              or (iii) invasion of privacy, right of publicity, defamation,
              libel, slander, copyright infringement, trademark infringement, or
              any other causes of action arising out of the use of the Personal
              Attributes of myself, my children or minors for whom I am a legal
              guardian. I further covenant not to sue any Releasee or cause any
              Releasee to be sued regarding any matter released above. I
              represent that I understand the nature of the Activities, and I
              ASSUME ALL RISKS associated with the hosting of, participation in
              or attendance at the activities, by myself, and my children and
              minors for whom I am a legal guardian.
            </p>
            <p style={styles.p}>
              I have read this Release, Waiver of Liability and Indemnity
              Agreement (this “Release”), understand that I have given up
              substantial rights by signing it and have signed it freely and
              without any inducement or assurance of any nature and intend it be
              a complete and unconditional release of all liability to the
              greatest extent allowed by law. I, on behalf of myself, and my
              children and minors for whom I am a legal guardian, hereby forever
              and irrevocably waive any and all rights to seek or obtain any
              injunctive or other equitable relief with respect to any matter
              within the scope of this Release, or to rescind, limit or
              disaffirm this Release. I further agree to indemnify and hold
              harmless each Releasee from and against any Loss regarding any
              matter within the scope of this Release. If any provision of this
              Release is unenforceable, it shall be modified to the extent
              reasonably necessary to make the provision legal, valid and
              binding, and the remainder of this Release shall remain
              enforceable to the full extent allowed by law. No statements
              regarding the effect of this Release, not contained in this
              Release, shall modify the terms of the Release. In any proceeding
              or other attempt to enforce, construe or to determine the validity
              of this Release, the nonprevailing party will pay the reasonable
              expenses of the prevailing party, including, without limitation,
              reasonable attorneys’ fees and costs. This Release shall be
              binding upon myself, my children and minors for whom I am a legal
              guardian, and our respective successors, assignees, subrogors,
              heirs, next of kin, legal and personal representatives, and anyone
              who obtains any rights from or through any of us.
            </p>
          </Fragment>
        )}
      </div>
    );
  }
}

export default CommunityWaiver;
